import React, { useState, useEffect } from 'react';
import { gamificationService } from '../../services/firestoreService';
import './PointsBadges.css';

const PointsBadges = ({ studentId }) => {
  const [points, setPoints] = useState(0);
  const [badges, setBadges] = useState([]);
  const [showBadges, setShowBadges] = useState(false);

  useEffect(() => {
    // Subscribe to points
    const unsubscribePoints = gamificationService.subscribeToStudentPoints(studentId, (totalPoints) => {
      setPoints(totalPoints);
    });

    // Subscribe to badges
    const unsubscribeBadges = gamificationService.subscribeToStudentBadges(studentId, (badgesList) => {
      setBadges(badgesList);
    });

    return () => {
      unsubscribePoints();
      unsubscribeBadges();
    };
  }, [studentId]);

  return (
    <div className="points-badges-widget">
      <div className="points-display" onClick={() => setShowBadges(!showBadges)}>
        <span className="points-icon">⭐</span>
        <span className="points-value">{points.toLocaleString()}</span>
        <span className="points-label">Points</span>
      </div>
      
      {badges.length > 0 && (
        <div className="badges-preview" onClick={() => setShowBadges(!showBadges)}>
          <span className="badge-count">{badges.length}</span>
          <span className="badge-icon">🏆</span>
        </div>
      )}

      {showBadges && (
        <div className="badges-modal">
          <div className="badges-header">
            <h3>🏆 Your Badges</h3>
            <button className="close-btn" onClick={() => setShowBadges(false)}>×</button>
          </div>
          <div className="badges-list">
            {badges.length === 0 ? (
              <p className="no-badges">No badges yet. Keep participating to earn badges!</p>
            ) : (
              badges.map((badge) => (
                <div key={badge.id} className="badge-item">
                  <div className="badge-icon-large">{badge.badgeIcon}</div>
                  <div className="badge-info">
                    <div className="badge-name">{badge.badgeName}</div>
                    <div className="badge-description">{badge.description}</div>
                    <div className="badge-date">
                      Earned: {new Date(badge.awardedAt).toLocaleDateString()}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PointsBadges;

